/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import { makeStyles } from '@fluentui/react-components';
import React from 'react';
import { BrainStormIcon, CopilotAnalystIcon, CopilotResearchIcon, TryCopilotIcon } from '../../../../assets/icons';

export enum LftSidePaneActionId {
    WhatCanIDo = 'WhatCanIDo',
    Brainstorm = 'Brainstorm',
    CreateImage = 'CreateImage',
    CompareFiles = 'CompareFile'
}

export enum LftCountdownActionId {
    ResearcherDialog = 'ResearcherDialog',
    BrainStormDialog = 'BrainStormDialog',
    AnalystDialog = 'AnalystDialog',
    TryCopilotDialog = 'TryCopilotDialog'
}

export type LftCountdownAction = {
    id: string;
    primaryContent: string;
    icon: React.ReactNode;
    onClick: () => void;
};

export const getIconForActionId = (actionId: string): React.ReactNode => {
    switch (actionId) {
        case LftCountdownActionId.ResearcherDialog:
            return <CopilotResearchIcon />;
        case LftCountdownActionId.AnalystDialog:
            return <CopilotAnalystIcon />;
        case LftCountdownActionId.BrainStormDialog:
            return <BrainStormIcon />;
        case LftCountdownActionId.TryCopilotDialog:
            return <TryCopilotIcon />;
        default:
            return null;
    }
};

export const useLftCountdownStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        maxWidth: '100%',
        margin: '0 auto',
    }
});
